import { useTranslation } from "react-i18next";
import React, { useState } from "react";
import { registersList } from "../../../config/sidebars/registers";
import PageWrapper from "../../components/common/layout/PageWrapper";
import { BoxSpg } from "@duosoftbg/nacid-components";
import { Grid } from "@mui/material";
import { ReactComponent as AcademicRecognitionLogo } from "@duosoftbg/nacid-components/dist/assets/images/icon-Diploma.svg";
import { ReactComponent as ProfQualificationLogo } from "@duosoftbg/nacid-components/dist/assets/images/icon-Prof-Qual.svg";
import TextCard from "../../components/common/cards/TextCard";
import Typography from "@mui/material/Typography";
import SearchSeRecognitionSection from "../../components/seRecognition/SearchSeRecognitionSection";

const Registers = () => {
  const { t } = useTranslation();
  const [registers] = useState(registersList);

  return (
    <PageWrapper centerTitle title={t("t.eRegisters")}>
      <BoxSpg mt={6}>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <SearchSeRecognitionSection />
        </Grid>
        <Grid container spacing={{ xs: 4, md: 5, lg: 7 }}>
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <TextCard
              to={"/academic-recognitions"}
              title={"t.page.academicRecognition"}
              icon={<AcademicRecognitionLogo />}
            >
              <Typography variant="body2" color="text.secondary" align={"justify"}>
                {t("m.academicRecognition.desc")}
              </Typography>
              <Typography style={{ marginTop: 10 }} variant="body2" color="text.secondary">
                <div style={{ fontWeight: "bold" }}>{t("m.academicRecognition.desc.2")}</div>
                <div>{t("m.academicRecognition.desc.3")}</div>
                <div>{t("m.academicRecognition.desc.4")}</div>
              </Typography>
            </TextCard>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <TextCard
              to={"/professional-qualifications"}
              title={"t.page.professionalQualifications"}
              icon={<ProfQualificationLogo />}
            >
              <Typography variant="body2" color="text.secondary" align={"justify"}>
                {t("m.professionalQualifications.desc")}
              </Typography>
              <Typography style={{ marginTop: 10, fontWeight: "bold" }} variant="body2" color="text.secondary">
                <div>{t("m.professionalQualifications.desc.2")}</div>
              </Typography>
            </TextCard>
          </Grid>

          {/*{registers.map((item) => (*/}
          {/*  <Grid key={item.href} item xs={12} sm={6} md={6} lg={6}>*/}
          {/*    <TextCard to={item.href} title={item.title} description={item.description} icon={item.icon} />*/}
          {/*  </Grid>*/}
          {/*))}*/}
        </Grid>
      </BoxSpg>
    </PageWrapper>
  );
};

export default Registers;
